import { render, staticRenderFns } from "./menu-btn.vue?vue&type=template&id=336ad784&scoped=true"
import script from "./menu-btn.vue?vue&type=script&lang=js"
export * from "./menu-btn.vue?vue&type=script&lang=js"
import style0 from "./menu-btn.vue?vue&type=style&index=0&id=336ad784&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336ad784",
  null
  
)

export default component.exports